import { TemplateElement, html, defineElement } from '@webtides/element-js';

export default class ListItem extends TemplateElement {
    constructor() {
        super({ shadowRender: true });
    }

    template() {
        return html` <slot></slot> `;
    }
}

defineElement('mb-list-item', ListItem);
